<template>
<section>
    <div class="wrap">
         <div class="title_box" style="margin-top: 15px; border-bottom: 1px solid #ddd; padding-bottom: 10px; margin-bottom: 0;">
            <select class="ui dropdown w70 w100p selection" v-model="type" style="height: 30px;">
                <option value="">전체</option>
                <option v-for="(type) in Object.values(FAQ_TYPE_CUSTOMER)" :key="`faq-type-customer-list-item-${type.id}`"
                    :value="type.id"
                >
                    {{type.title}}
                </option>
            </select>
        </div>
    </div>
    
    <div class="wrap" style="border: none; padding-top: 0;">
        <ul class="menu_ul notice_list">
            <li v-for="(faq) in faqItemsFilter" :key="`faq-find-list-item-${faq.id}`">
                <router-link :to="`/faqInfo/${faq.id}`">
                    {{faq.title}}
                </router-link>
                <!--<a @click="answerShow(faq)">
                    {{faq.title}}
                </a>-->
            </li>  
        </ul>
    </div>
</section>  
</template>

<script>
import { mapState } from 'vuex';

export default {
    name:'FaqList',
    async created () {
        this.$store.state.headerTitle = '자주 묻는 질문';
        //this.filters.mapId = this.FAQ_DTYPE.CUSTOMER.id;
        
        await this.$store.dispatch('GET_FAQ_LIST', {
            typeList: this.typeList,
            dtype: this.FAQ_DTYPE.CUSTOMER.id,
        })

        this.$store.commit('SHOW_ONLOAD');
    },
    data() {
        return {
            filters: {...this.$store.state.faq.filters},
            type: '',
            showId: 0,
        }
    },
    watch: {
        type() {
            this.showId = 0;
        }
    },
    computed: {
        ...mapState({
            faqItems : state => state.faq.items,
            FAQ_DTYPE: state => state.codeDictionary.items.FAQ_DTYPE,
            FAQ_TYPE_CUSTOMER: state => state.codeDictionary.items.FAQ_TYPE_CUSTOMER,
        }),
        typeList() {
            return Object.values(this.FAQ_TYPE_CUSTOMER).map( e => e.id).join(',');
        },

        faqItemsFilter(){
            return this.faqItems.filter(e => (this.type) ? (e.type == this.type) : true);
        }
    },
    methods: {
        answerShow(faq) {
            if(faq.id == this.showId) return this.showId = 0;
            return this.showId = faq.id;
        }
    },
}
</script>

<style scoped>

</style>
<style>
.answer_dev {
    background-color: #ededed;
}
    #app {
        background:#fff
    }
    .menu_ul li {
        padding: 5px 10px;
    }
</style>